const loadPort = loaderFunction =>
  loaderFunction().then(module => module.default);

const portsInventory = portsMap => {
  const map = new Map(Object.entries(portsMap));

  return {
    get(type) {
      const port = map.get(type);

      return typeof port !== 'function'
        ? Promise.resolve(port)
        : loadPort(port);
    },
  };
};

export default portsInventory;
